import type { CompetitionView } from '@ps/web-sports-api-types';
import React from 'react';

import { Title } from '@swf/sports/components';
import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';

import CompetitionTitle from './CompetitionTitle';

interface Props {
  groupedOn: 'DATE' | 'COMPETITION';
  isNested: boolean;
  panelName: string;
  competition: CompetitionView;
}

const TemplatePanelTitle: React.FC<Props> = ({ groupedOn, isNested, panelName, competition }) => {
  const shouldShowLogo = groupedOn === 'COMPETITION' && !!competition.logoUrl;
  return (
    <Title
      isNested={isNested}
      isLight
      hasIcon={shouldShowLogo}
      hasLink={groupedOn === 'COMPETITION' && isNested}
    >
      {groupedOn === 'DATE' ? (
        <FormattedDateTime date={panelName} format="long" weekday="long" hideTime />
      ) : (
        <CompetitionTitle isNested={isNested} competition={competition} />
      )}
    </Title>
  );
};

export default TemplatePanelTitle;
